export enum ClearanceApprovalTypeEnum {
  INSURANCE = "insurance",
  WORKSHOP = "workshop",
  CUSTOMER = "customer"
}
